import { H3 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { addImageParams, AddImageParamTypes } from '@/utils/urls';

type Props = {
    imageUrl: string;
    isTwoColumnLayout?: boolean;
    link: string;
    shouldUseSmallImageInset?: boolean;
    title: string;
};

export const CategoryModuleCard = ({
    imageUrl,
    isTwoColumnLayout = false,
    link,
    shouldUseSmallImageInset = false,
    title,
}: Props) => {
    const imageParams: AddImageParamTypes = {
        height: 160,
        url: imageUrl,
    };

    return (
        <div className={cn('min-w-0', isTwoColumnLayout ? 'w-[calc((100%-theme(spacing.sm))/2)] grow-0' : 'flex-1')}>
            <RouteLink
                className="relative flex w-full flex-col items-center gap-sm bg-background-primary no-underline smMin:gap-md"
                to={link}
            >
                <div
                    className={cn(
                        'relative block w-full justify-center overflow-hidden bg-background-subdued',
                        shouldUseSmallImageInset ? 'p-xs' : 'p-xs smMin:px-md smMin:py-sm'
                    )}
                >
                    <img
                        alt={title}
                        className="w-full"
                        loading="lazy"
                        src={addImageParams(imageParams)}
                    />
                </div>
                <H3>{title}</H3>
            </RouteLink>
        </div>
    );
};
